import * as React from 'react'

const SvgCurrentFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.25c-4.75 0-8.75 4-8.75 8.75s4 8.75 8.75 8.75 8.75-4 8.75-8.75-4-8.75-8.75-8.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgCurrentFilledIcon
